// @flow @jsx h

import { h, Component } from 'preact'

import style from './index.css'

type Props = {
  align: 'left' | 'right',
  title: string,
  content: string,
  byline: string,
  alt: string,
  date: string,
  width: number
}

type State = {}

export class DefaultCard extends Component<Props, State> {
  render () {
    const { title, width, date, alt } = this.props
    const wrapperInlineStyle = {}

    return (
      <div className={style.defaultCard} style={{ width: width + 'px' }}>
        <div
          className={style.defaultCard__wrapper}
          style={wrapperInlineStyle}>
          <header>
            <h3>{date}</h3>
            <p>{title}</p>
          </header>
          <div className='nrk-sr' role='img' alt={alt} />
          <a href='https://www.nrk.no/tidslinje-for-orderud-saken_-dette-er-de-viktigste-hendelsene-1.14242619'>
            Se hele tidslinjen for Orderud-saken
          </a>
        </div>
      </div>
    )
  }
}
